<template>
  <div>
    <section class="feature-area" style="padding: 20px 0">
      <div style="padding:30px">
        <el-timeline :reverse="false" style="min-height: 200px">
          <el-timeline-item
            v-for="(record, index) in records"
            :key="index"
            :timestamp="record.createTime"
          >
            {{ record.statusDesc }}
          </el-timeline-item>
        </el-timeline>
      </div>
    </section>
  </div>
</template>

<script>
import { add, getUserResume, getResumeRecords } from "@/api/resume";
export default {
  data() {
    return {
      name: "",
      records: [],
    };
  },
  mounted() {
    this.doGetRecords();
  },
  methods: {
    doGetRecords() {
      getResumeRecords().then((res) => {
        this.records = res.data.data;
      });
    },
  },
};
</script>


<style  scoped>
.base-info {
  display: flex;
  /* justify-content: space-around; */
  flex-wrap: wrap;
}
.base-items {
  width: 370px;
  display: flex;
  flex-direction: column;
  /* justify-content: flex-end; */
}
.item {
  margin: 10px 0;
  /* width: 400px; */
}
.item-right {
  display: flex;
  justify-content: flex-end;
  /* align-self: center; */
}

.item .item-name {
  margin-right: 10px;
}
.item .item-info {
  margin-right: 10px;
  width: 200px;
}

.flex-item {
  display: flex;
  flex-direction: row;
  justify-items: center;
  align-self: center;
}
.create-buttom {
  display: flex;
  align-self: center;
  justify-content: center;
}
</style>





// WEBPACK FOOTER //
// ResumeRecords.vue?c0da96e0